// extracted by mini-css-extract-plugin
export var centerText = "_dk-8";
export var container = "_dk-0";
export var doughnutContainer = "_dk-7";
export var legend = "_dk-a";
export var legendItemColorDisplay = "_dk-b";
export var legendItemLabel = "_dk-d";
export var legendItemValue = "_dk-c";
export var lg = "_dk-5";
export var maxWidth = "_dk-9";
export var md = "_dk-4";
export var responsive = "_dk-6";
export var sm = "_dk-3";
export var xs = "_dk-2";
export var xxs = "_dk-1";